import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../common/models/Message";
import { MoneyState } from "../models/MoneyState";

const setMessage = (state: MoneyState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;